import { useTranslation } from 'react-i18next'

// local imports
import { IFilteredLactationRoomList } from 'types/LactationType'
import {
  ReservationButton,
  RoomName,
  RoomLocation,
  WorkingHours,
  StyledCard,
  CardHeaderOverlay,
  RoomCapacity,
  Summary,
  // FavoriteContainer,
} from './styled'
// import { useState } from 'react'
// import LactationService from 'service/LactationService'
// import FavoriteIconButton from 'components/ui/FavoriteIconButton'

interface ComponentProps {
  room: IFilteredLactationRoomList
  openModal: (salon: IFilteredLactationRoomList) => void
}

export default function LactationRoomCard({ room, openModal }: ComponentProps) {
  const { t } = useTranslation()
  /* ######### Lactation Room Data Destructuring ######### */
  const {
    // Id,
    name,
    startHourStr,
    endHourStr,
    reservationCapacity: maxCapacity,
    reservationCount,
    explanation,
    // IsFavorite,
    floor: { name: FloorName, locationName: floorLocationName, districtName, cityName, countryName, blockName },
  } = room || {}

  /* Variables - functions */
  const locationName = `${floorLocationName}, ${districtName}, ${cityName}, ${countryName}, ${blockName}, ${FloorName}`
  const reservationCapacityDisplay = `${reservationCount}/${maxCapacity}`

  const openSearchModal = () => openModal(room)

  /* Favorite Lactation Room */
  // const [favorite, setFavorite] = useState(IsFavorite)
  // const handleAddFavorite = () => {
  //   LactationService.addLactationRoomFavorite(Id).then((r) => setFavorite(true))
  // }
  // const handleRemoveFavorite = () => {
  //   LactationService.removeLactationRoomFavorite(Id).then((r) => setFavorite(false))
  // }

  return (
    <StyledCard>
      <CardHeaderOverlay>
        {/* <FavoriteContainer>
          <FavoriteIconButton onSave={handleAddFavorite} onRemove={handleRemoveFavorite} isFavorite={favorite} />
        </FavoriteContainer> */}
      </CardHeaderOverlay>

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <RoomName>{`${name}`}</RoomName>
          <RoomLocation>{locationName}</RoomLocation>
          <RoomCapacity>
            <i className="pi pi-users"></i>
            <span>{reservationCapacityDisplay}</span>
          </RoomCapacity>
          <Summary>{explanation}</Summary>
        </div>
        <WorkingHours>
          <span className="wh-title">{t('most-used-words.working-hours')}: </span>
          <span>
            {startHourStr} - {endHourStr}
          </span>
        </WorkingHours>
        <ReservationButton onClick={openSearchModal}>{t('buttons.book-reservation')}</ReservationButton>
      </div>
    </StyledCard>
  )
}
